import { defaultSchema, type Options as SanitizeSchema } from 'rehype-sanitize'

/**
 * Custom HTML tags emitted by Copilot markdown preprocessing for rehype-raw.
 * Must stay allowlisted so sanitization does not drop chart / table tokens.
 */
const CHART_TOKEN_TAG = 'chart-token'
const COPILOT_TABLE_TAG = 'copilot-table'
/** Skill pill placeholder in user messages (see `buildSkillPillMarkdown`). */
const SKILL_PILL_TAG = 'skill-pill'

/** KaTeX input markers from remark-math → mdast-util-to-hast (before rehype-katex). */
const MATH_INLINE_CLASS = 'math-inline'
const MATH_DISPLAY_CLASS = 'math-display'
const MATH_CLASS = 'math'

const DEFAULT_DIV_ATTRIBUTES = defaultSchema.attributes?.div ?? []
const DEFAULT_SPAN_ATTRIBUTES = defaultSchema.attributes?.span ?? []
const DEFAULT_TAG_NAMES = defaultSchema.tagNames ?? []

/**
 * Sanitize schema for Copilot markdown after `rehype-raw`.
 *
 * - Extends GitHub-style `defaultSchema` (no scripts / event handlers / iframes).
 * - Allows Copilot custom elements and KaTeX math class markers so `rehype-katex`
 *   can run safely *after* sanitization.
 */
export const markdownSanitizeSchema: SanitizeSchema = {
  ...defaultSchema,
  tagNames: [...DEFAULT_TAG_NAMES, CHART_TOKEN_TAG, COPILOT_TABLE_TAG, SKILL_PILL_TAG],
  attributes: {
    ...defaultSchema.attributes,
    [CHART_TOKEN_TAG]: ['dataId', 'dataType'],
    [COPILOT_TABLE_TAG]: ['dataId'],
    [SKILL_PILL_TAG]: ['dataIndex'],
    div: [...DEFAULT_DIV_ATTRIBUTES, ['className', MATH_CLASS, MATH_DISPLAY_CLASS]],
    span: [...DEFAULT_SPAN_ATTRIBUTES, ['className', MATH_CLASS, MATH_INLINE_CLASS]]
  }
}
